import { render, staticRenderFns } from "./RemoveIcon.vue?vue&type=template&id=34c73b7a"
import script from "./RemoveIcon.vue?vue&type=script&lang=ts"
export * from "./RemoveIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports